<template>
    <!-- style="max-width: 1100px; margin: auto; font-size: 1.5rem;" -->
  <div style="margin: auto; font-size: 1.5rem;" class="grey lighten-3" >
  <v-app>

    <v-flex xs12>
    <v-toolbar color="pink" dark >

      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <v-toolbar-title><router-link to="/">简历</router-link> <small><router-link to="/en">https://i.ch2n.com/#/en</router-link></small></v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn> -->
    </v-toolbar>
    </v-flex>

    <v-card>
      <v-container fluid grid-list-lg >

        <v-layout row wrap>

          <v-flex xs12>

            <v-card color="blue-grey darken-2" class="white--text">

              <v-layout row style="word-break: break-word;">

                <v-flex>
                  <v-card-title primary-title>
                    <div>
                      <div class="title font-weight-medium mb-1" >陈淦</div>
                      <div>10 年经验</div>
                      <div>i@ch2n.com</div>
                      <div>+86-131-2287-9925</div>
                    </div>
                  </v-card-title>
                </v-flex>

                    <!-- src="https://i.loli.net/2020/05/31/NCe6DnU2xoQa4dY.jpg" -->
                <v-contianer align-end>
                <v-flex mt-1 mr-2>
                  <v-img
                  class="align-end mt-2"
                    src="../assets/Untitled.png"
                    height="145px"
                    width="145px"
                    contain
                  ></v-img>
                </v-flex>
                </v-contianer>

              </v-layout>

              <v-divider light></v-divider>

              <v-card-actions class="pa-3">
                <v-layout row>
                  <v-flex>
                    <div>Consistently delivered top-tier performance, looking for a position of AgentEngineer/AIOps/DevOps/SRE.</div>
                  </v-flex>
                  <!-- <v-flex class="xs5">
                    <div>Shanghai Polytechnic University</div>
                  </v-flex> -->
                  <!-- <v-flex class="xs4">
                    <div>majored in Electronic Commerce</div>
                  </v-flex> -->
                </v-layout>
              </v-card-actions>

            </v-card>
          </v-flex>


          <v-flex xs12>
            <v-card  style="word-break: break-word;">
            
              <v-card-title primary-title>
                <div style="line-height: 1.35 !important">

                <v-flex class="mb-0 pb-0 mt-0 pt-0">
                  <h3 class="headline mb-0 pb-0 blue--text">概况</h3>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - 性格: </span> 传统内敛，宽容随和，做事细致深入，思维缜密，有主人公思维，有结果导向意识。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - Linux: </span> 能够按照 <a class="blue-grey--text text--lighten-1" href="https://www.linuxfromscratch.org/" target="_blank">Linux From Scratch</a> 构建最小的 Linux 发行版。
                      但对内核各子系统和 eBPF 尚无深入研究。高效的 terminal 操作及 bash 脚本。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - Programing: </span> 偏好 async iterator, full type annotation 等 Python 语言特性，但不熟悉元编程，Rust 入门级(手写代码量少于1万行)，可 vibe coding 制作<a class="blue--text text--darken-1" href="https://github.com/carlos-chen-tb/awsconnect" target="_blank">日常工作需要重复使用的工具</a>。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - Kubernetes/云:</span> 多年 k8s/Istio 生产经验, 熟悉 AWS EC2/Lambda/ECS/EKS, 包括支撑性服务如 AppConfig, CloudTrail, CloudFormation, CloudWatch, CostAnomaly, TrustHub 等。IaC 风格偏好原子化 terragrunt 加全外部 terraform module。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - Splunk 专家: </span> 能够从零建立集群，熟悉各种组件的配置，开发扩展 APP，创建交互式 dashboard，撰写<a class="blue--text text--darken-1" href="https://gitee.com/x2c/tmp/blob/main/splunk/query_tips.md" target="_blank">高效精确的查询</a>来追踪错误与定量定损。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - AI/LLM:</span> 对 Transformer, CoT/ToT, Tool Calling/ReAct, MCP, RAG, Context/Harness Engineering 等概念有粗浅理解。正在尝试工程经验 agent 可长期重用, 及构建 self-improving 工作流两个方向。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - 优秀的排错能力:</span> 用户行为层(亿级用户超大规模环境)，网络层(dns， ip/tcp，tls，mtls，certificate，http，istio，container，grpc)，服务依赖层，或者 codebase，CI/CD，infra-as-code，configuration-as-code 层。能够快速定位并处理绝大多数常见问题并给出准确解释, 有更多时间来设计与 coding.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - 保持状态:</span> 2025年完赛两场半程马拉松(均2小时内), 羽毛球从新手到3级水平(业余球场80%分位)。
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold blue-grey--text text--lighten-2" style="font-size: 1.6rem;">
                   - 我的限制:</span> <a class="blue-grey--text text--lighten-1" href="https://cert.efset.org/yY3Goy" target="_blank">中级水平(B2)的英语</a>, 有时花费过高代价追究根因与原理。
                  </div>
                </v-flex>

                </div>
              </v-card-title>
            </v-card>
          </v-flex>


          <v-flex xs12>
            <v-card  style="word-break: break-word;">
              <v-card-title primary-title body-2>

                <div style="line-height: 1.35 !important">

                <v-flex class="mb-0 pb-0 mt-0 pt-0">
                  <h3 class="headline mb-0 pb-0 blue--text">工作经历</h3>
                </v-flex>

                <v-flex>
                    <div class="mb-1">
                      <span class="font-weight-bold deep-purple--text text--darken-4" style="font-size: 1.6rem;">DevSecOps Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://www.thirdbridge.com/" target="_blank">Third Bridge</a> 2024.09 - </span>
                    </div>
                    <div class="mb-1"> 
                      - 拥有较大的 scope 与超级权限, 主要工作在 CI/CD, IaC, Observability, 少量在 FinOps, Security。
                    </div>
                    <div class="mb-1">
                      - 年度 GitHub Org <span class="font-weight-bold">排名前三的贡献者</span>（1800 个 commit、500 个 PR、15% 的 code review），偿还了诸多技术债，带来诸多开发体验提升, 以及成本优化。
                    </div>
                    <div class="mb-1">
                      - 调查并修复持续多年的 S3 VPC endpoint 绑定错误导致的 nat-gateway 高额流量费用，年节省超过 80,000 美元。
                    </div>
                    <div class="mb-1">
                      - 在 IaC 流水线中取消了持续多年而不必要的 docker_layer_caching 使用，仅本单一 repo 年节省超过 9,606 美元，并将该优化推广到其它仓库。
                    </div>
                    <div class="mb-1">
                      - 梳理 serverless 流水线中的逻辑 bug，年节省超过 2,087 美元。 更多成本节省按下不表，如 AMI (月600美元)，CloudWatch Dashboard (月600美元)等清理。
                    </div>
                    <div class="mb-1">
                      - 将某 nodejs service 的构建流水线时长从 20 分钟缩短到 3 分钟，并将这些优化 template 化（CircleCI orb jobs and commands)，以供其它服务复用。
                    </div>
                    <div class="mb-1">
                      - 模板化所有 pipeline 常用公共部分，以提高整体 CI/CD 效率和质量，降低维护成本，避免重复。从单一步骤如环境切换与认证，到完整 job 如特定语言构建流程，不一而足。
                    </div>
                    <div class="mb-1">
                      - 构建 Splunk 导入 CircleCI metrics，精准发现 pipeline 资源误用，如链式 trigger 但长时间运行最后失败无人知晓。通过 trigger 频率, 失败率, 平均时长等指标发现优化点。
                    </div>
                    <div class="mb-1">
                      - 设计一套通用的 CloudWatch Metric Alarm (SNS+lambda+slack+terragrunt alarm 定义)，使某个新 service 能够快速扩展补充 alarm 定义，多次及时告警服务中断。
                    </div>
                    <div class="mb-1">
                      - 安全: 揭示出 pipeline OIDC role 攻击面过大的事实, 从基础组件开始修复权限授予的 steps, 推进 fine-grained permission roles。
                    </div>
                </v-flex>

                <v-flex>
                    <div class="mb-1">
                      <span class="font-weight-bold deep-purple--text text--darken-4" style="font-size: 1.6rem;">Site Reliability Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://www.quest-global.com/" target="_blank">Apple Pay (AWF)</a> 2022.12 - 2024.09</span>
                    </div>
                    <div class="mb-1"> - Apple Pay APAC SRE team 外包员工，发薪水的是 Quest Global，在顶级用户规模和及其优秀的工程质量环境中工作。
                    </div>
                    <div class="mb-1">
                      - <span class="font-weight-bold">追踪超大规模下的复杂用户行为</span>，依赖最多的是熟练的 splunk 查询技巧，多次成功发现隐蔽的业务错误，及时止损，避免不为人知的可观损失。
                    </div>
                    <div class="mb-1">
                      - 处理任何环节可能出现的问题, 依赖的是对所有相关代码的深入理解: 环境涉及多k8s集群, 跨集群及对 partner mTLS 通信，基于 Istio 的灰度部署及流量管控，基于helm的自定义CI/CD 流程, 以及 properties/configuration as code, 基于 Splunk 的 logging 加基于 Prometheus metric 的 observability。大部份 workload 为常规 Deployment, 也涉及 Apache Spark CRD。
                    </div>
                    <div class="mb-1">
                      - 脚本分析或处理各种内部系统的数据，大多数情况下这依然是处理生产问题的一部分，有时则是一些工具性质(CI/CD链条，本地工具)。
                    </div>
                </v-flex>

                <v-flex >
                    <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb1" style="font-size: 1.6rem;">Site Reliability Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://stubhub.com" target="_blank">Stubhub Shanghai Imformation Technology Ltd</a> 2020.8 - 2022.8</span>
                    </div>
                    <div class="mb-1"> - 由于与母公司 eBay 分离，我们需要将所有服务从 eBay 的数据中心迁移到 GCP。
                      我负责 Splunk 服务，成功将 Splunk 集群<span class="font-weight-bold">无缝过渡到 GKE</span> (Kubernetes managed by Google Cloud)，持续为整个组织提供稳定的日志记录、警报和 dashbord 功能。
                      日数据量最高为 5TB，大于 1k 个客户端。容器化所有 Splunk 组件(deployer, indexer, search head, license manager, GCP pub/sub extention…), 子网互通, 数据治理及持久化, 配置变更及部署。
                      </div>
                    <div class="mb-1"> 
                      - 此外，还需要协同管理维护所有其他内部支撑系统，实现各系统间的集成，puppet/terraform/ansible/jenkins/nexus/自建 yum 源/自建 CICD 平台，nginx + spring boot + react + spring batch + oracle + kafka + solr + nfs, Jira, Slack, NewRelic, PagerDuty...
                    </div>
                </v-flex>

                <v-flex >
                    <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb1" style="font-size: 1.6rem;">
                      Operations Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://techown.com" target="_blank">Shanghai Techown Imformation Technology Ltd</a> 2019.4 - 2020.8</span>
                    </div>
                    <div class="mb-1">
                      - 为了解决业务人员无法及时获得关键业务指标的问题，我从零开始构建了一个 Splunk 集群，<span class="font-weight-bold">创建了 30 多个交互式仪表板和许多告警来报告关键业务指标，
                        为钉钉警报开发了第三方应用程序，编写了多个脚本和程序</span>来满足客户需求并优化整个数据处理工作流程。这是一个描述这个过程的 slides: <a class="blue--text text--darken-1" href="https://gitee.com/x2c/tmp/blob/main/slides/A_slide.key" target="_blank">https://gitee.com/x2c/tmp/blob/main/slides/A_slide.key</a> 
                    </div>
                    <div class="mb-1">
                      - 这是我制作的一个<span class="font-weight-bold">示例 dashboard</span>: <a class="blue--text text--darken-1" href="https://i.loli.net/2020/07/13/1sqizeWZkE35cFB.png" target="_blank">https://i.loli.net/2020/07/13/1sqizeWZkE35cFB.png</a>
                    </div>
                </v-flex>

                <v-flex >
                    <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb5" style="font-size: 1.6rem;">
                      Operations Engineer 
                      <a class="font-weight-bold blue-grey--text text--darken-2" href="https://www.i8xiaoshi.com" target="_blank">several </a> 
                      <a class="font-weight-bold blue-grey--text text--darken-2" href="http://www.houhao.cn" target="_blank">modestly </a> 
                      <a class="font-weight-bold blue-grey--text text--darken-2" href="http://www.cloudvsp.com/" target="_blank">sized </a> 
                      <a class="font-weight-bold blue-grey--text text--darken-2" href="http://www.lnuo.com.cn/" target="_blank">companies</a> 2016.3 - 2019.4</span>
                    </div>
                    <div class="mb-1">
                      - 职业生涯的头三年里，我辗转于几家规模不大的公司，总是独立工作。
                        这些工作大多属于传统运维工程师的范畴，包括主机和服务管理。下面介绍一些<span class="font-weight-bold">主要成就</span>。
                    </div>

                    <div class="mb-1">
                      - 针对一个 SaaS Web 产品，通过将服务迁移到 docker 并在更少的虚拟机中运行各个组件， 包括 nodejs、redis、mongo、mysql、java 和 .Net 服务， 
                        实现了阿里云<span class="font-weight-bold">成本降低 30%</span>。
                        还将 <span class="font-weight-bold">HA 功能引入到生产中</span>: nginx+keepalived LB、keepalived + redis(master slave+sentinel)、mongo(replica set)、mysql(dual master)，
                        将 Deployment Runbook 从手动迁移到 shell 迁移到 ansible 迁移到 docker。
                    </div>

                    <div class="mb-1">
                      - 在一个初创团队，<span class="font-weight-bold">从零开始建立整个办公室 IT 基础设施</span>，包括硬件和软件。
                        管理路由器、交换机、服务器、服务器机架、电话交换系统、固定电话和笔记本电脑的选型， 采购和配置。
                        设计网络，<span class="font-weight-bold">配置 Windows 域</span>， 包含 WDS+MDT、CIFS、WSUS、CA 和 VPN。
                        <span class="font-weight-bold">配置 pfSense </span>来管理 IDC 中服务器的网络，建立与办公网络的站点到站点 OpenVPN 连接，<span class="font-weight-bold">实施 Zabbix </span>进行全面的操作系统和硬件监控。
                    </div>

                </v-flex>
              
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card color="cyan darken-2" class="white--text ">
              <v-card-title primary-title body-2>
                <div class="d-flex headline mb-1">教育</div>
                <div>
                      <div class="mb-1"> - 2012 - 2016，上海第二工业大学，电子商务专业</div>
                      <div class="mb-1"> - 大多数课程都是关于利用 Java 构建电子商务网站，采用的是一些现在看起来过时的技术，例如 Java 1.6、Spring MVC、Struts2 和 Hibernate。</div>
                      <div class="mb-1"> - 我对探索那些<span class="font-weight-bold text--darken-2">看起来很骇客</span>的知识有着浓厚的兴趣，
                        例如构建 100MB 以下的最小 Windows 映像，使用包括 Kali 在内的 Linux 桌面，
                        使用仅包含几个开机启动进程的最小 Android ROM，以及 iOS 越狱等等。
                      </div>
                </div>
              </v-card-title>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <div>
                  非常感谢您花时间阅读这份简历，它的在线版本为 <a href="https://i.ch2n.com/#/en">https://i.ch2n.com/</a>
                </div>
                <v-spacer></v-spacer>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>

      </v-container>
    </v-card>

  </v-app>
  </div>
</template>

<script>
export default {
  name: 'En',
  components: {
  }
}

</script>

<style scoped>
a {
  color: #424242;
}
body {
    /*en,zh,mac,windows,linux,ios,android*/
    font: 14px/1.5 Arial,Helvetica,"Lucida Grande","Helvetica Neue",'PingFang SC',"Hiragino Sans GB","Hiragino Sans GB W3","Microsoft YaHei","WenQuanYi Microhei","Heiti SC","STHeiti","Noto Sans CJK SC","Source Han Sans CN",sans-serif; 
}
</style>
